module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data02-2fcd1037068c356ecb511bf0fa8d4b6a.png";